import classnames from "classnames";

import styles from "@components/v2/graphic_elements/DividerRule.module.css";

const DividerRule = () => <div className={classnames("component-DividerRule", styles.divider)} />;

export default DividerRule;
